import React from "react";
import { useNavigate } from "react-router-dom";
import "./Story.css";
import "./contentpage.css";

function ForewordLightning() {
  const navigate = useNavigate();

  const handleBegin = () => {
    navigate("/lightning-91"); //
  };
  return (
    <div className="story-page">
      <div className="story-container">
        بسم الله الرحمن الرحيم
        <h1 className="story-title">Curators Foreword</h1>
        <h3>Fundamentals of Lightning Tech</h3>
        <p className="story-text">
          <p className="story-text">
            This section explores the Lightning Network, a Layer-2 payment
            network built on top of Bitcoin and currently the most widely used
            scaling solution for it. In the previous section, we examined how
            Bitcoin functions as a piece of software and how every transaction
            on the network must be validated and stored by nodes. While this
            design ensures security and decentralization, it also introduces
            natural limits to how much transaction data the base layer can
            handle without compromising these core principles.
            <br />
            <br />
            This is precisely where the Lightning Network becomes essential.
            Lightning enables users to make instant, low-cost payments without
            placing unnecessary strain on the Bitcoin blockchain. Instead of
            recording every individual transaction on the base layer, Lightning
            allows users to transact off-chain while ensuring that only final
            settlements are recorded on the blockchain. In doing so, it
            preserves Bitcoin’s decentralization while dramatically improving
            its usability as a medium of exchange.
            <br />
            <br />
            Through this section, the learner will gain an understanding of how
            Lightning works, why it is necessary, and how it complements Bitcoin
            rather than competing with it. The goal is not to overwhelm the
            learner with technical complexity, but to provide sufficient clarity
            to appreciate how Lightning enables Bitcoin to scale for everyday
            payments while remaining secure, decentralized, and trust-minimized.
            <br />
            <br />
            By the end of this section, the learner will be better equipped to
            understand how Bitcoin evolves as a monetary network and how Layer-2
            solutions like Lightning play a critical role in its real-world
            adoption.
            <br />
            <br /> The learner receives a badge at both the beginning and the
            completion of this section. The term “graduate” is purely figurative
            and is used only to congratulate the learner and gamify the learning
            process.
            <br />
            <br />
            Each lesson includes a dashboard with a timer, a summary paragraph,
            and four MCQs to test understanding.
            <br />
            <br />
            The ideal pace is one lesson per day, though learners may adjust
            according to their capacity.
          </p>
        </p>
        {/* BUTTON */}
        <button className="popup-close-btn" onClick={handleBegin}>
          Let us begin!
        </button>
      </div>
    </div>
  );
}

export default ForewordLightning;
